import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import {
	postModule,
	updateModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { Subscription } from 'rxjs';

interface translateModalModule {
	title: string;
	titleUpdate: string;
	name: string;
	description: string;
	nameRequired: string;
	placeholderName: string;
	placeholderDescription: string;
	titleDrag: string;
	textDrag: string;
	buttonSave: string;
	buttonCancel: string;
	textInfo: string;
	regexInvalid: string;
}
@Component({
	selector: 'app-modal-new-module',
	templateUrl: './modal-new-module.component.html',
	styleUrls: ['./modal-new-module.component.scss'],
})
export class ModalNewModuleComponent implements OnInit, OnDestroy {
	fileUrl: string = '';
	select: string = '';
	nameModule: string = '';
	descriptionModule: string = '';
	translateModal: translateModalModule = {} as translateModalModule;
	subscriptionTranslate!: Subscription;
	isDragActive = false;
	public formGroup!: FormGroup;

	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalNewModuleComponent>,
		private translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}
	ngOnInit(): void {
		this.buildForm();
		this.dataTranslate();
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.systemModules.modalModules;
		});
	}

	private buildForm() {
		const name = '';
		this.fileUrl = this.data.data.logo || '';
		this.formGroup = this.formBuilder.group({
			name: [
				this.data.data.name,
				[Validators.required, Validators.maxLength(50), Validators.pattern(/V[0-9]+([.][0-9]+)?$/)],
			],
			description: [this.data.data.description],
		});
	}

	get f() {
		return this.formGroup.controls;
	}
	onNoClick(): void {
		this.dialogRef.close();
	}

	urlUploadedHandle(event: any) {
		this.fileUrl = event.url;
	}

	urlUploadedErrorHandle(event: any) {
		console.error(event);
	}

	public onDragOver() {
		this.isDragActive = true;
	}

	public onDragLeave(event: Event) {
		this.isDragActive = false;
	}
	save() {
		if (this.formGroup.valid) {
			const module: Module = {
				name: this.formGroup.value.name,
				description: this.formGroup.value.description,
				logo: this.fileUrl,
			} as Module;
			if (this.data.type === 'update') {
				this.store.dispatch(updateModule({ pk: this.data.data.pk, sk: this.data.data.sk, module }));
				this.onNoClick();
			} else {
				this.store.dispatch(postModule({ module }));
				this.onNoClick();
			}
		}
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
